import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const Time = (props: Icon): React.ReactElement => (
  <svg
    style={{ ...style(props.size, props.height), ...props.style }}
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <path
        d="M12,3.99999995 C16.418278,3.99999995 20,7.58172197 20,12 C20,16.418278 16.418278,20 12,20 C7.58172197,20 3.99999995,16.418278 3.99999995,12 C3.99999995,7.58172197 7.58172197,3.99999995 12,3.99999995 Z M12,5.33333329 C8.31810165,5.33333329 5.33333329,8.31810165 5.33333329,12 C5.33333329,15.6818984 8.31810165,18.6666667 12,18.6666667 C15.6818984,18.6666667 18.6666667,15.6818984 18.6666667,12 C18.6666667,8.31810165 15.6818984,5.33333329 12,5.33333329 Z M12,6.66666663 C14.9455187,6.66666663 17.3333334,9.05448132 17.3333334,12 C17.3333334,14.9455187 14.9455187,17.3333334 12,17.3333334 C9.05448132,17.3333334 6.66666663,14.9455187 6.66666663,12 C6.66666663,9.05448132 9.05448132,6.66666663 12,6.66666663 Z M12,7.99999998 C9.79086099,7.99999998 7.99999998,9.79086099 7.99999998,12 C7.99999998,14.209139 9.79086099,16 12,16 C14.209139,16 16,14.209139 16,12 C16,9.79086099 14.209139,7.99999998 12,7.99999998 Z M12,9.33333332 C12.3418906,9.33333332 12.6236714,9.59069345 12.6621815,9.92225257 L12.6666667,9.99999999 L12.6666667,12.6666667 C12.6666667,13.0085572 12.4093065,13.2903381 12.0777474,13.3288482 L12,13.3333333 L9.99999999,13.3333333 C9.63181015,13.3333333 9.33333332,13.0348565 9.33333332,12.6666667 C9.33333332,12.3247761 9.59069345,12.0429952 9.92225257,12.0044852 L9.99999999,12 L11.3333333,12 L11.3333333,9.99999999 C11.3333333,9.65810943 11.5906935,9.37632854 11.9222526,9.33781847 L12,9.33333332 Z"
        id="path-1-time"
      ></path>
    </defs>
    <g
      id="icon-24x24px[16x16px]---line&amp;solid"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Atom/icon/time/clock/line">
        <mask id="mask-2-time" fill="white">
          <use xlinkHref="#path-1-time"></use>
        </mask>
        <use
          id="Combined-Shape"
          fill="#FFFFFF"
          fillRule="nonzero"
          xlinkHref="#path-1-time"
        ></use>
        <g
          id="Group"
          mask="url(#mask-2-time)"
          fill={props.color || theme.palette.grey600}
        >
          <g id="🎨-color">
            <rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
